import { LOADING, NEEDED, COMPLETED, GROUPS, DOCUMENTS, GROUPSCATEGORIES } from './constants';
import axios from 'axios';
import env from '../../environment';
import authClient from '../../Auth/Auth';

export const getOperationDocuments = (userToken, mortgageId) => async (dispatch) => {
	axios
		.get(`${env.api.url}/v1/documents/request-operation-documentation/${mortgageId}`, {
			headers: { Authorization: `Bearer ${userToken}` }
		})
		.then((response) => {
			if (response.data.success) {
				let excludedNames = [
					'consent_ibercaja',
					'consent_caixabank',
					'consent_sabadell_saas',
					'consent_bankinter',
					'consent_unicaja',
					'consent_abanca',
					'consent_globalcaja',
					'consent_caja_rural_sur',
					'consent_kutxabank',
					'consent_bbva'
				];
				if (authClient.getProfile().managementCode === 'sabadell-es') {
					excludedNames = excludedNames.filter((name) => name !== 'consent_sabadell');
				}

				const data = response.data.data;
				const validDocuments = Object.values(data.documents).filter(
					(doc) => doc && doc.title && typeof doc.title === 'string'
				);

				const apiDocuments = validDocuments
					.filter((doc) => !excludedNames.includes(doc.name))
					.sort((a, b) => a.title.localeCompare(b.title));
				const apiGroupsUnmapped = data.groups;

				const apiGroups = Object.keys(apiGroupsUnmapped).map((key) => {
					return {
						name: key,
						title: apiGroupsUnmapped[key].title,
						hasDocumentTypes: apiGroupsUnmapped[key].hasDocumentTypes
					};
				});

				dispatch({
					type: LOADING,
					payload: false
				});

				dispatch({
					type: NEEDED,
					payload: data.documentsNeeded
				});

				dispatch({
					type: COMPLETED,
					payload: data.documentsCompleted
				});

				dispatch({
					type: DOCUMENTS,
					payload: apiDocuments
				});

				dispatch({
					type: GROUPS,
					payload: apiGroups
				});

				dispatch({
					type: GROUPSCATEGORIES,
					payload: data.groups
				});
			} else {
				console.error('fallo la carga de documentos', response.data);
			}
		});
};
